import axios from "axios";

const SET_SURVEY_RESULTS = "SET_SURVEY_RESULTS";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

const getSurveyResults = (state) => state?.surveyResults;
const getSurveyData = (state) => state?.surveyData;
const getAccountSessionToken = (state) => state?.loginReducer?.token;

const initialState = {
  surveyResults: null,
  surveyData: null,
};

export const surveyResultsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SURVEY_RESULTS:
      const { data } = action;
      return {
        ...state,
        surveyResults: data?.surveyResponse,
        surveyData: data?.surveyDefinition,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchSurveyResults =
  (surveyDefinitionId, participantId) => (dispatch) => {
    const params = {
      surveyDefinitionId,
      participantId,
    };
    return axios
      .get(`/api/survey/response`, { params })
      .then(({ data }) => {
        return dispatch({
          type: SET_SURVEY_RESULTS,
          data,
        });
      })
      .catch((e) => {
        return Promise.reject(
          e.response?.data
            ? e.response.data
            : "There was an error while trying to fetch Survey Results."
        );
      });
  };

export const mapStateToProps = (state) => {
  return {
    surveyResults: getSurveyResults(state),
    surveyData: getSurveyData(state),
    token: getAccountSessionToken(state),
  };
};

export const mapDispatchToProps = {
  fetchSurveyResults,
  resetState,
};
